<form autocomplete="off" [formGroup]="formSiniestrosConsulta">
  <section class="row">

    <div class="col-md-2">
      <mat-form-field class="inputFormulario" color="primary">
        <mat-label>Oficina</mat-label>
        <mat-select formControlName="idOficina" placeholder="Oficina">
          @for (valor of catalogos.catOficinas; track valor) {
            <mat-option [value]="valor.id">
              {{valor.nombre | titlecase }}
            </mat-option>
          }
        </mat-select>
        @if (this.formSiniestrosConsulta.get('idOficina').value) {
          <button matSuffix mat-icon-button
            aria-label="Clear" (click)="this.formSiniestrosConsulta.get('idOficina').reset()">
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (this.formSiniestrosConsulta.get('idOficina').value) {
          <mat-hint>
            <i class="fas fa-check"></i> Correcto
          </mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-12">
      <mat-form-field (click)="IniVigencia.open()" class="inputFormulario">
        <mat-label>Fecha inicio</mat-label>
        <app-input-fecha-actualizacion [picker]="IniVigencia" [minFecha]="null" [maxFecha]="null"
          placeholder="Fecha inicio" formControlName="fechaRegistroInicial">
        </app-input-fecha-actualizacion>
        <mat-datepicker-toggle tabindex="-1" matPrefix [for]="IniVigencia"></mat-datepicker-toggle>
        <mat-datepicker #IniVigencia></mat-datepicker>
      </mat-form-field>
      <!-- <mat-error *ngIf="formSiniestrosConsulta.hasError('dateRangeInvalid')">La fecha desde no puede ser mayor que la fecha vigencia.</mat-error> -->
    </div>
    <div class="col-md-3 col-12">
      <mat-form-field (click)="FinVigencia.open()" class="inputFormulario">
        <mat-label>Fecha final</mat-label>
        <app-input-fecha-actualizacion [picker]="FinVigencia" [minFecha]="null" [maxFecha]="null"
          placeholder="Fecha final" formControlName="fechaRegistroFinal">
        </app-input-fecha-actualizacion>
        <mat-datepicker-toggle tabindex="-1" matPrefix [for]="FinVigencia"></mat-datepicker-toggle>
        <mat-datepicker #FinVigencia></mat-datepicker>
      </mat-form-field>
      @if (formSiniestrosConsulta.hasError('dateRangeInvalid')) {
        <mat-error>La fecha hasta no puede ser anterior a la fecha inicio de vigencia.</mat-error>
      }
    </div>

    <div class="col-md-3 col-12">
      <mat-form-field class="inputFormulario" color="primary">
        <mat-label>Estatus</mat-label>
        <mat-select formControlName="idEstatus" placeholder="Estatus">
          @for (valor of catalogos.catEstatus; track valor) {
            <mat-option [value]="valor.id">
              {{valor.nombre | titlecase }}
            </mat-option>
          }
        </mat-select>
        @if (this.formSiniestrosConsulta.get('idEstatus').value) {
          <button matSuffix mat-icon-button
            aria-label="Clear" (click)="this.formSiniestrosConsulta.get('idEstatus').reset()">
            <mat-icon>close</mat-icon>
          </button>
        }
        @if (this.formSiniestrosConsulta.get('idEstatus').value) {
          <mat-hint>
            <i class="fas fa-check"></i> Correcto
          </mat-hint>
        }
      </mat-form-field>
    </div>
  </section>
</form>